export const InteractivePromoIcon = () => {
	return (
		<svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      fill="none"
      viewBox="0 0 60 60"
    >
      <path
        fill="#6C3BFF"
        d="M58.727.343H1.455C.636.343 0 .943 0 1.714v56.657c0 .772.636 1.372 1.455 1.372h57.09c.819 0 1.455-.6 1.455-1.372V1.714c.09-.771-.545-1.371-1.273-1.371zm-1.454 56.571H3.09v-54h54.182v54z"
      ></path>
      <path
        fill="#6C3BFF"
        d="M14.818 12.343v13.543c0 1.371 1 2.314 2.455 2.314h27.909c1.454 0 2.454-.943 2.454-2.314V12.343c0-1.372-1-2.314-2.454-2.314H17c-1.182.085-2.182 1.028-2.182 2.314zM44.91 25.886H17V12.343h27.91v13.543z"
      ></path>
      <path
        fill="#6C3BFF"
        d="M21.818 17.914h6.455c.363 0 .818-.343.818-.771v-.772c0-.342-.364-.771-.818-.771h-6.455c-.364 0-.818.343-.818.771v.772c.09.343.273.771.818.771zM32.545 17.914h6.546c.364 0 .818-.343.818-.771v-.772c0-.342-.364-.771-.818-.771h-6.455c-.363 0-.818.343-.818.771v.772c0 .343.364.771.727.771zM44.909 31.8H17c-1.455 0-2.455.943-2.455 2.314v13.543c0 1.372 1 2.314 2.455 2.314h27.909c1.455 0 2.455-.942 2.455-2.314V34.114c0-1.371-1-2.314-2.455-2.314zm0 15.857H17V34.114h27.909v13.543z"
      ></path>
    </svg>
	);
};
